<script setup>
</script>

<template>
  <span
    class="tw-px-4 tw-py-2 tw-bg-info-100 tw-border tw-border-info-700 tw-rounded-2.5xl tw-text-info-700 tw-font-bold tw-text-xs tw-uppercase tw-shrink-0 tw-flex-grow-0 tw-flex tw-items-center tw-gap-1 tw-mr-auto"
  >
    <span class="tw-inline-block tw-w-2.5 tw-h-2.5 tw-mr-2 tw-align-middle tw-rounded-full tw-bg-info-600 tw-animate-pulse tw-shrink-0 tw-grow-0" />
    Connected
  </span>
</template>
